import { CircularProgress, LinearProgress } from "@mui/material";
import React, { useState, useEffect, useCallback, useRef } from "react";
import Cropper from "react-easy-crop";
import { useContextApi } from "../../../context/ContextApi";
import { CheckIcon, PlusIcon, XIcon } from "../../../constants/Icons";

const AddImage = ({ onClose, data,ImageView,Ontrigger=true, onAdd }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [imagePreview, setImagePreview] = useState(ImageView
    ? ImageView
    : "/assets/images/avatars/default.jpg");
  const [imageFile, setImageFile] = useState(null);
  const fileInputRef = useRef(null);
  const hasFetched= useRef(null);
  const {useEscapeKey}=useContextApi();
  useEscapeKey(onClose)

  // Cropper states
  const [cropMode, setCropMode] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [fileSize, setFileSize] = useState(0);

  useEffect(() => {
    if (data) {
      setImagePreview(typeof data === "string" ? data : URL.createObjectURL(data));
      setImageFile(data);
    }
  }, [data]);

  const handleImageClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // fileInputRef.current.value = "";
      setFileSize(file.size);
      simulateSizeBasedUpload(file.size);

      setTimeout(() => {
        setImageFile(file);
        setImageSrc(URL.createObjectURL(file));
        setCropMode(true);
        setIsUploading(false);
        setUploadProgress(0);
      }, 800);
    }
  };

  const simulateSizeBasedUpload = (size) => {
    setIsUploading(true);
    setUploadProgress(0);
    const chunkSize = Math.max(10000, Math.floor(size / 100));
    let uploaded = 0;
    const interval = setInterval(() => {
      uploaded += chunkSize;
      const progress = Math.min(100, Math.floor((uploaded / size) * 100));
      setUploadProgress(progress);
      if (uploaded >= size) clearInterval(interval);
    }, 50);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const getCroppedImage = async () => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const croppedImage = await cropImage(imageSrc, croppedAreaPixels);

      setUploadProgress(100);

      const croppedFile = dataURLtoFile(croppedImage, "cropped-image.jpeg");

      setTimeout(() => {
        setImagePreview(croppedImage);
        setImageFile(croppedFile);
        setCropMode(false);
        setIsUploading(false);
        setUploadProgress(0);
        handleSubmit(croppedFile);
      }, 300);
    } catch (error) {
      console.error("Crop failed:", error);
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  //  FIXED CROPPING FUNCTION
  const cropImage = (imageSrc, pixelCrop) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );

        resolve(canvas.toDataURL("image/jpeg"));
      };
      image.onerror = reject;
    });
  };

  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };


  const handleSubmit = (file) => {
    const uploadFile = file || imageFile; // use passed file or fallback to state
    if (!uploadFile) return;
  
    setIsUploading(true);
    setUploadProgress(0);
    simulateActualUpload(uploadFile.size, uploadFile);
  };
  
  const simulateActualUpload = (size, file) => {
    let uploaded = 0;
    const chunkSize = Math.max(10000, Math.floor(size / 100));
  
    const interval = setInterval(() => {
      uploaded += chunkSize;
      const progress = Math.min(100, Math.floor((uploaded / size) * 100));
      setUploadProgress(progress);
  
      if (progress >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          setIsUploading(false);
          onAdd(file); //  send the correct cropped file
        }, 300);
      }
    }, 50);
  };

  // const handleSubmit = () => {
  //   if (!imageFile) return;
  //   setIsUploading(true);
  //   setUploadProgress(0);
  //   simulateActualUpload(imageFile.size);
  // };

  // const simulateActualUpload = (size) => {
  //   let uploaded = 0;
  //   const chunkSize = Math.max(10000, Math.floor(size / 100));
  //   const interval = setInterval(() => {
  //     uploaded += chunkSize;
  //     const progress = Math.min(100, Math.floor((uploaded / size) * 100));
  //     setUploadProgress(progress);
  //     if (progress >= 100) {
  //       clearInterval(interval);
  //       setTimeout(() => {
  //         setIsUploading(false);
  //         onAdd(imageFile);
  //       }, 300);
  //     }
  //   }, 50);
  // };

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      if (Ontrigger) {
        setTimeout(() => {
          handleImageClick();
        }, 300);
      }
    }
  },[]);

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop show" onClick={onClose}></div>
      <div className="modal show" id="CustomerModal" tabIndex="-1" aria-modal="true" role="dialog" style={{ display: "block" }}>
        <div className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">{cropMode ? "Crop Image" : "Add Image"}</h6>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body bg-light">
              {isUploading && (
                <div className="mb-3">
                  <div className="d-flex justify-content-between mb-1">
                    <span className="small text-muted">Processing...</span>
                  </div>
                  <LinearProgress variant="determinate" value={uploadProgress} sx={{ height: 8, borderRadius: 4 }} />
                  <div className="text-center mt-1 small text-muted">{uploadProgress}% Complete</div>
                </div>
              )}

              {!cropMode ? (
                <div className="col-12 text-center">
                  <div className="profile-picture p-2 d-flex justify-content-center">
                    <div className="profile-img-container position-relative" onClick={handleImageClick}>
                      <img
                        id="logoimg"
                        className="avatar"
                        src={imagePreview}
                        alt="profile-img"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "2px solid #ddd",
                        }}
                      />
                      <div className="overlay-icon">
                        <PlusIcon/>
                      </div>
                    </div>
                  </div>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/jpeg,image/png,image/webp,image/gif"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    disabled={isUploading}
                  />
                </div>
              ) : (
                <div>
                  <div className="crop-container" style={{ position: "relative", width: "100%", height: "300px" }}>
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      rotation={rotation}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="modal-footer d-block">
              {!cropMode ? (
                <>
                  <button type="button" className="btn btn-outline-secondary text-left" onClick={onClose} disabled={isUploading}>
                    <XIcon/> Cancel
                  </button>
                  {isUploading ? (
                    <button className="btn btn-primary pb-0 text-right" disabled>
                      <CircularProgress size={22} className="text-white" />
                    </button>
                  ) : (
                    <button type="button" className="btn btn-primary text-right" onClick={handleSubmit} disabled={!imageFile || isUploading}>
                      <CheckIcon/> Submit
                    </button>
                  )}
                </>
              ) : (
                <>
                  <button type="button" className="btn btn-outline-secondary text-left" onClick={() => setCropMode(false)} disabled={isUploading}>
                    <XIcon/> Cancel
                  </button>
                  {isUploading ? (
                    <button className="btn btn-primary pb-0 text-right" disabled>
                      <CircularProgress size={22} className="text-white" />
                    </button>
                  ) : (
                    <button type="button" className="btn btn-primary text-right" onClick={getCroppedImage}>
                      <CheckIcon/> Crop & Save
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddImage;
